import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AwaitModules, Button, ComponentSync, LL_H_C, LL_V_L, TS_CollapsableContainerV2 } from '@nu-art/thunderstorm-frontend';
import { PertinentData } from '../../../../_utils/PertinentData/PertinentData.js';
import { exists } from '@nu-art/ts-common';
import './Component_PertinentData.scss';
import { ModuleFE_AdvisorAnalytics } from '../../../../_analytics/consts.js';
import { ModuleFE_AdvisorState } from '@app/advisor-frontend';
class Component extends ComponentSync {
    //######################### Life Cycle #########################
    __onRuntimePertinentDataUpdated = (...params) => {
        this.setState({ items: PertinentData.sort(PertinentData.getAllRenderable()) });
    };
    deriveStateFromProps(nextProps, state) {
        state.items ??= PertinentData.sort(PertinentData.getAllRenderable());
        state.collapsed ??= ModuleFE_AdvisorState.getStateProperty.collapsing.homePanel.pertinentData() ?? false;
        state.expandStateMap ??= {};
        return state;
    }
    componentDidMount() {
        this.reportLoadAnalytics();
        this.setCollapseInitialValue();
    }
    componentDidUpdate() {
        this.reportLoadAnalytics();
        this.setCollapseInitialValue();
    }
    //######################### Logic #########################
    reportLoadAnalytics() {
        //01/11/2026 - EM generates all categories even if they have no content.
        // If the items.length is 0, pertinent data has not finished calculating - delay the report
        if (ModuleFE_AdvisorAnalytics.eventsHaveTriggered('uiLoad_pertinentData') || !this.state.items.length)
            return;
        const itemCount = this.state.items.reduce((sum, item) => sum + item.item.entries.length, 0);
        ModuleFE_AdvisorAnalytics.trigger.uiLoad.uiLoad_pertinentData({
            categoryCount: this.state.items.length,
            itemCount,
            elapsed_ms: ModuleFE_AdvisorAnalytics.getTimeSinceLoad(),
        });
    }
    setCollapseInitialValue() {
        if (!this.state.items.length || exists(ModuleFE_AdvisorState.getStateProperty.collapsing.homePanel.pertinentData()))
            return;
        ModuleFE_AdvisorState.setProperty.collapsing.homePanel.pertinentData(false);
        this.setState({ collapsed: false });
    }
    toggleExpandState = (item) => {
        const newState = !this.state.expandStateMap[item.item._id];
        const categoryLabel = item.getLabel();
        this.setState({ expandStateMap: { ...this.state.expandStateMap, [item.item._id]: newState } });
        if (newState) {
            ModuleFE_AdvisorAnalytics.trigger.pertinent.pertinentData_categoryOpen({ categoryLabel, itemCount: item.item.entries.length });
        }
        else {
            ModuleFE_AdvisorAnalytics.trigger.pertinent.pertinentData_categoryCollapse({ categoryLabel });
        }
    };
    allExpanded = () => this.state.items.every(item => this.state.expandStateMap[item.item._id]);
    toggleAllExpandState = (e) => {
        e.stopPropagation();
        const allExpanded = this.allExpanded();
        this.state.items.forEach(item => this.state.expandStateMap[item.item._id] = !allExpanded);
        this.forceUpdate();
        if (allExpanded)
            ModuleFE_AdvisorAnalytics.trigger.pertinent.pertinentData_collapseAllCategories();
        else
            ModuleFE_AdvisorAnalytics.trigger.pertinent.pertinentData_expandAllCategories();
    };
    toggleComponentCollapse = (collapsed) => {
        this.setState({ collapsed });
        if (collapsed) {
            ModuleFE_AdvisorState.setProperty.collapsing.homePanel.pertinentData(true);
            ModuleFE_AdvisorAnalytics.trigger.pertinent.pertinentData_collapsed();
        }
        else {
            const itemCount = this.state.items.reduce((sum, item) => sum + item.item.entries.length, 0);
            ModuleFE_AdvisorState.setProperty.collapsing.homePanel.pertinentData(false);
            ModuleFE_AdvisorAnalytics.trigger.pertinent.pertinentData_expanded({
                categoryCount: this.state.items.length,
                itemCount
            });
        }
    };
    //######################### Render #########################
    render() {
        if (!this.state.items.length)
            return;
        return _jsx(TS_CollapsableContainerV2, { forceUpdate: true, className: 'c__pertinent-data', headerRenderer: this.render_Header(), containerRenderer: this.render_Items(), collapsed: this.state.collapsed, onCollapseToggle: () => {
                if (this.state.collapsed)
                    return;
                this.toggleComponentCollapse(true);
            } });
    }
    render_Header = () => {
        return _jsxs(_Fragment, { children: [_jsxs(LL_V_L, { className: 'c__header', children: [_jsx("h1", { children: "Pertinent Patient Data" }), _jsx("h2", { children: "Review your patient's medical history here" })] }), this.render_HeaderButton()] });
    };
    render_HeaderButton = () => {
        if (this.state.collapsed)
            return _jsx(Button, { variant: 'primary', onClick: e => {
                    e.stopPropagation();
                    this.toggleComponentCollapse(false);
                }, children: "View" });
        const buttonLabel = this.allExpanded() ? 'Collapse All' : 'Expand All';
        return _jsx(Button, { variant: 'secondary', onClick: this.toggleAllExpandState, children: buttonLabel });
    };
    render_Items = () => {
        return _jsx(LL_V_L, { className: 'c__pertinent-data__sections', children: this.state.items.map(this.render_Item) });
    };
    render_Item = (item) => {
        const entries = item.getContent();
        return _jsx(TS_CollapsableContainerV2, { onCollapseToggle: () => this.toggleExpandState(item), collapsed: !this.state.expandStateMap[item.item._id], headerRenderer: item.getLabel, containerRenderer: () => _jsx(LL_V_L, { className: 'c__pertinent-data__entries', children: entries.map(entry => {
                    return _jsxs(LL_H_C, { className: 'c__pertinent-data__entry', children: [_jsx("p", { className: 'entry-text', children: entry.text }), exists(entry.timestamp) && _jsx("div", { className: 'entry-timestamp', children: entry.timestamp })] }, entry.key);
                }) }) }, item.item._id);
    };
}
export const Component_PertinentData = (p) => _jsx(AwaitModules, { modules: PertinentData.modulesToAwait, Component: () => _jsx(Component, { ...p }) });
//# sourceMappingURL=Component_PertinentData.js.map